import type React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './NoSpecSelected.module.css';

export const NoSpecSelected: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.icon}>📋</div>
      <h2 className={styles.title}>No Specification Selected</h2>
      <p className={styles.message}>
        To use this feature, you need to select an active API specification. Please go to the Specifications Registry
        and set a specification as active.
      </p>
      <button className={styles.button} onClick={() => navigate('/specifications')}>
        Go to Specifications
      </button>
    </div>
  );
};
